import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import {flattenCommodity} from "../utils/cargo";
import * as utilsCargo from "../utils/cargo";

const initialState = {
    cargoes: [],
    current: null,
    loading: false,
    saving: false,
    deleting: false,
    formData: {}
};

export default function cargo(state = initialState, action) {
    let newState = Object.assign({}, state);
    let found = false;

    switch (action.type) {
        case actions.LOADING_CARGO:
            newState.loading = true;
            break;

        case actions.SAVING_CARGO:
            newState.saving = true;
            break;

        case actions.DELETING_CARGO:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_CARGO:
            newState.deleting = false;
            break;

        case actions.RECEIVED_CARGOES:
            newState.loading = false;
            newState.cargoes = utils.mapById(utilsCargo.calculateShortage(flattenCommodity(action.payload)));
            break;

        case actions.RECEIVED_CARGO:
            newState.loading = false;
            newState.current = action.payload;
            break;

        case actions.SAVED_CARGO:
            for (let i = 0; i < newState.cargoes.length; i++) {
                if(newState.cargoes[i].id === action.payload.id){
                    found = true;
                    newState.cargoes[i] = action.payload;

                    if (utils.notNullNorUndefined(newState.cargoes[i].commodity)) {
                        newState.cargoes[i].commodityName = newState.cargoes[i].commodity.name;
                    }

                    if (utils.notNullNorUndefined(newState.cargoes[i].outturnTonnes) && newState.cargoes[i].outturnTonnes > 0) {
                        newState.cargoes[i].shortageTonnes = newState.cargoes[i].quantity - newState.cargoes[i].outturnTonnes;
                        newState.cargoes[i].shortagePercent = newState.cargoes[i].shortageTonnes / newState.cargoes[i].quantity;
                    }
                }
            }

            if(!found) {
                newState.cargoes.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.SAVED_CARGO_PORT:
            for (let i = 0; i < newState.cargoes.length; i++) {
                if(newState.cargoes[i].id === action.payload.cargo.id){
                    newState.cargoes[i] = action.payload.cargo;
                }
            }
            break;

        case actions.ERROR_SAVING_CARGO:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.UPDATEFORMDATA_CARGO:
            newState.formData = action.payload.formData;
            break;

        case actions.CLEARFORMDATA_CARGO:
            newState.formData = {};
            break;

        default: break;
    }
    return newState;
}


// WEBPACK FOOTER //
// ./src/reducers/cargo.js